const prod = require("./config.prod");
const staging = require("./config.staging");
const dev = require("./config.dev");

let config;

if (process.env.ACTIVE_ENV === "PRODUCTION") {
	config = prod;
} else if (process.env.ACTIVE_ENV === "STAGING") {
	config = staging;
} else {
	config = dev;
}

module.exports = config;
